import React from 'react';
import { Link } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const BlogCard = ({ article }) => {
  const getDifficultyColor = (level) => {
    const colors = {
      beginner: 'text-success bg-success/10',
      intermediate: 'text-warning bg-warning/10',
      advanced: 'text-error bg-error/10'
    };
    return colors?.[level] || colors?.beginner;
  };

  const getCategoryIcon = (category) => {
    const icons = {
      'Full-Stack': 'Layers',
      'Performance': 'Zap',
      'Architecture': 'Box',
      'DevOps': 'Server',
      'Frontend': 'Layout',
      'Backend': 'Database'
    };
    return icons?.[category] || 'FileText';
  };

  return (
    <article className="group bg-card border border-border rounded-lg overflow-hidden hover:shadow-lg hover:border-primary/50 transition-all duration-300">
      <div className="relative h-48 md:h-56 lg:h-64 overflow-hidden">
        <Image
          src={article?.image}
          alt={article?.imageAlt}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-4 left-4 flex items-center gap-2">
          <span className={`px-3 py-1 rounded-full text-xs font-bold ${getDifficultyColor(article?.difficulty)}`}>
            {article?.difficulty?.charAt(0)?.toUpperCase() + article?.difficulty?.slice(1)}
          </span>
        </div>
      </div>
      <div className="p-4 md:p-5 lg:p-6">
        <div className="flex items-center gap-3 mb-3">
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <Icon name={getCategoryIcon(article?.category)} size={14} />
            <span>{article?.category}</span>
          </div>
          <span className="text-xs text-muted-foreground">•</span>
          <div className="flex items-center gap-1 text-xs text-muted-foreground">
            <Icon name="Clock" size={14} />
            <span>{article?.readTime} min read</span>
          </div>
        </div>

        <h3 className="text-lg md:text-xl font-bold font-heading text-foreground mb-2 line-clamp-2 group-hover:text-primary transition-colors duration-300">
          {article?.title}
        </h3>

        <p className="text-sm text-muted-foreground mb-4 line-clamp-3">
          {article?.excerpt}
        </p>

        <div className="flex items-center justify-between pt-4 border-t border-border">
          <div className="flex items-center gap-2">
            <Image
              src={article?.authorImage}
              alt={article?.authorImageAlt}
              className="w-8 h-8 rounded-full object-cover"
            />
            <div>
              <p className="text-xs font-medium text-foreground">{article?.author}</p>
              <p className="text-xs text-muted-foreground">{article?.date}</p>
            </div>
          </div>

          <Link
            to={`/technical-blog/${article?.slug}`}
            className="flex items-center gap-1 text-sm font-medium text-primary hover:gap-2 transition-all duration-300"
          >
            <span>Read More</span>
            <Icon name="ArrowRight" size={16} />
          </Link>
        </div>

        {article?.tags && article?.tags?.length > 0 && (
          <div className="flex flex-wrap gap-2 mt-4">
            {article?.tags?.slice(0, 3)?.map((tag, index) => (
              <span
                key={index}
                className="px-2 py-1 text-xs rounded bg-muted text-muted-foreground"
              >
                #{tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </article>
  );
};

export default BlogCard;